import { Pill } from "@src/appV2/redesign/system/ui-components";

export function ShiftUnavailablePill() {
  return (
    <Pill disabled label="Shift is unavailable" iconType="info" sx={{ width: "fit-content" }} />
  );
}
